import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=3f354af0&scoped=true"
import script from "./Keywords.vue?vue&type=script&lang=js"
export * from "./Keywords.vue?vue&type=script&lang=js"
import style0 from "./Keywords.vue?vue&type=style&index=0&id=3f354af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f354af0",
  null
  
)

export default component.exports